import type { ISearchRequestPagingDTOData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import { clampSearchPaging } from '~/features/catalog/searchResultWindow';

export const QUERY_SEARCH_PARAM_CATALOG_HWGID = 'cHwgId';
export const QUERY_SEARCH_PARAM_CATALOG_HAGRID = 'cHagrId';
export const QUERY_SEARCH_PARAM_CATALOG_AGRID = 'cAgrId';
export const QUERY_SEARCH_PARAM_PAGE = 'page';
export const QUERY_SEARCH_PARAM_PAGESIZE = 'pagesize';
export const QUERY_SEARCH_PARAM_SEARCHTERM = 'searchTerm';
export const QUERY_ORIGINAL_SEARCH_PARAM_SEARCHTERM = 'originalSearchTerm';
export const QUERY_SEARCH_PARAM_BRANDS = 'brands';
export const QUERY_SEARCH_PARAM_ROHSTOFFHERKUNFT = 'rh';
export const QUERY_SEARCH_PARAM_HERGESTELLT = 'h';
export const QUERY_SEARCH_PARAM_TK = 'tk';
export const QUERY_SEARCH_PARAM_ECOSCORE = 'es';
export const QUERY_SEARCH_PARAM_LABELS = 'ls';
export const QUERY_SEARCH_PARAM_SUPPLIERGROUPNAMES = 'sgn';
export const QUERY_SEARCH_PARAM_SPECIALDIET = 'sd';
export const QUERY_SEARCH_PARAM_SPECIAL_ASSORTMENT = 'sa';
export const QUERY_SEARCH_PARAM_ACTION = 'a';
export const QUERY_SEARCH_PARAM_ALLERGEN = 'alg';
export const QUERY_SEARCH_PARAM_NOVELTIES = 'n';
export const QUERY_SEARCH_PARAM_HWGID = 'hwg';
export const QUERY_SEARCH_PARAM_CA = 'ca';
export const defaultPageSize: number = 100;

function getStringParam(searchParams: URLSearchParams, key: string): string | null | undefined {
  return searchParams.has(key) ? searchParams.get(key) : undefined;
}

function getBooleanParam(searchParams: URLSearchParams, key: string): boolean | undefined {
  return searchParams.has(key) ? searchParams.get(key) === 'true' : undefined;
}

function getIntParam(searchParams: URLSearchParams, key: string, fallback: number): number {
  if (!searchParams.has(key)) {
    return fallback;
  }
  const value = Number.parseInt(searchParams.get(key)!);
  return Number.isNaN(value) ? fallback : value;
}

// Kommaseparierte Id-Liste, z.B. "1,2,3" -> [1, 2, 3]
function getNumberListParam(searchParams: URLSearchParams, key: string): number[] {
  const value = searchParams.get(key);
  if (value && value.length > 0) {
    return value.split(',').map(a => Number.parseInt(a, 10));
  }
  return [];
}

function parseSingleIdList(id: string | null | undefined): number[] | undefined {
  return id ? [Number.parseInt(id)] : undefined;
}

export const mapSearchParamsToSearchRequest = (
  searchParams: URLSearchParams = new URLSearchParams(window.location.search)
): ISearchRequestPagingDTOData => {
  const hwgId = getStringParam(searchParams, QUERY_SEARCH_PARAM_CATALOG_HWGID);
  const hagrId = getStringParam(searchParams, QUERY_SEARCH_PARAM_CATALOG_HAGRID);
  const agrId = getStringParam(searchParams, QUERY_SEARCH_PARAM_CATALOG_AGRID);

  const searchTerm = getStringParam(searchParams, QUERY_SEARCH_PARAM_SEARCHTERM) ?? '';
  const hwg = getNumberListParam(searchParams, QUERY_SEARCH_PARAM_HWGID);
  const { page, pageSize } = clampSearchPaging(
    getIntParam(searchParams, QUERY_SEARCH_PARAM_PAGE, 0),
    getIntParam(searchParams, QUERY_SEARCH_PARAM_PAGESIZE, defaultPageSize)
  );

  return {
    searchTerm: searchTerm,
    hwgIds: searchTerm.length > 0 ? hwg : parseSingleIdList(hwgId),
    hagrIds: parseSingleIdList(hagrId),
    agrIds: parseSingleIdList(agrId),
    page: page,
    pageSize: pageSize,
    brands: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_BRANDS),
    rohstoffHerkunft: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_ROHSTOFFHERKUNFT),
    specialDiet: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_SPECIALDIET),
    hergestellt: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_HERGESTELLT),
    tk: getBooleanParam(searchParams, QUERY_SEARCH_PARAM_TK),
    ecoScore: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_ECOSCORE),
    allergene: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_ALLERGEN),
    labels: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_LABELS),
    supplierGroups: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_SUPPLIERGROUPNAMES),
    specialAssortments: getNumberListParam(searchParams, QUERY_SEARCH_PARAM_SPECIAL_ASSORTMENT),
    action: getBooleanParam(searchParams, QUERY_SEARCH_PARAM_ACTION),
    novelties: getBooleanParam(searchParams, QUERY_SEARCH_PARAM_NOVELTIES),
    searchInCoreAssortment: getBooleanParam(searchParams, QUERY_SEARCH_PARAM_CA)
  };
};
